module.exports = __webpack_public_path__ + "img/Slide51.39dc4c30.png";